import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import MenuBody from './MenuBody';
import NotificationSettings from '../NotificationSettings';
import NotificationButton from '../NotificationButton';
import SiteLogo from '../SiteLogo';
import useReducedMotion from '../../hooks/useReducedMotion';

const DesktopSidebar = ({ darkMode, onToggleTheme }) => {
  const reduceMotion = useReducedMotion();
  const [isNotificationSettingsOpen, setIsNotificationSettingsOpen] = useState(false);

  const handleMenuAction = useCallback((action) => {
    if (action === 'notifications') setIsNotificationSettingsOpen(true);
  }, []);

  return (
    <aside
      className="hidden lg:flex lg:self-start flex-col shrink-0 w-72 sticky top-4 z-20 h-[calc(100vh-2rem)] overflow-y-auto overscroll-contain bg-white dark:bg-dark rounded-2xl border border-gray-200 dark:border-gray-700"
      aria-label="Site menu"
    >
      {/* On lg the header is hidden; logo and bell live here */}
      <div className="flex items-center justify-between gap-2 pl-4 pr-3 py-2 border-b border-gray-200 dark:border-gray-700">
        <Link to="/" aria-label="Main-Bet home" className="flex h-11 items-center">
          <SiteLogo className="h-8 w-auto" />
        </Link>
        <NotificationButton reduceMotion={reduceMotion} />
      </div>
      <MenuBody
        compactHeader
        onAction={handleMenuAction}
        darkMode={darkMode}
        onToggleTheme={onToggleTheme}
      />
      <NotificationSettings
        isOpen={isNotificationSettingsOpen}
        onClose={() => setIsNotificationSettingsOpen(false)}
      />
    </aside>
  );
};

export default DesktopSidebar;
